import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { deletepopdescDispatch } from 'reducers/HomeReducer';

export default function PopularDestinationTable() {
	const { pdInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const columns = [
		{ field: 'id', headerName: 'ID', width: 90 },
		{
			field: 'imgpath',
			headerName: 'Image',
			width: 150,
			height: 300,
			editable: true,
			renderCell: (params) => <img src={params.value} style={{ height: 50 }} />,
		},
		{
			field: 'destination',
			headerName: 'Destination',
			width: 600,
			editable: true,
		},
		{
			field: 'updated_at',
			headerName: 'Upload On',
			width: 600,
			editable: true,
		},
		{
			field: 'action',
			headerName: 'Action',
			width: 300,
			editable: true,
			renderCell: (cellValues) => {
				return (
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Button
							variant='contained'
							color='primary'
							style={{ marginLeft: 10 }}
							onClick={(event) => {
								handleClickDelete(event, cellValues);
							}}>
							Delete
						</Button>
					</Box>
				);
			},
		},
	];
	const handleClick = (event, cellValues) => {
		console.log('id', cellValues.id);
	};
	const handleClickDelete = (event, cellValues) => {
		console.log('id', cellValues.id);
		dispatch(deletepopdescDispatch(cellValues.id));
	};
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			{pdInfo && pdInfo?.banner.length > 0 ? (
				<DataGrid
					rows={pdInfo?.banner}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 5,
							},
						},
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
